<div class="body" id="topheader" *ngIf="isScreen">
    <nav class="navbar">
        <div class="container-fluid">
          <div class="navbar-header">
            <a class="imglogo" href="https://ecell.in" target="_blank"><img src="assets/images/logoblk.png" alt="E-Cell"></a>
            <div [className]="isnotOpen ? 'ham' : 'ham openham'"  (click) = toggleDisplay($event)>
                <!-- <i class="fa-solid fa-bars fa-2xl"></i> -->
                <span [className]="isnotOpen ? 'top' : 'top-open'"></span>
                <span [className]="isnotOpen ? 'mid' : 'mid-open'"></span>
                <span [className]="isnotOpen ? 'bottom' : 'bottom-open'"></span>
                
              </div>
          </div>
          <!-- <ul class="nav navbar-nav">
            
          </ul> -->
          <!-- <button>Toggle</button> -->
          <ul class="nav navbar-nav navbar-right switches extra">
            <li><a href="#">Home<div class="underline active"></div></a></li>
            <!-- <li><a [routerLink]="['/land']">Home2<div class="underline active"></div></a></li> -->
            <li [routerLink]="['/structure']"><a >Structure<div class="underline"></div></a></li>
            <li [routerLink]="['/tracks']"><a>Tracks<div class="underline"></div></a></li>
            <li [routerLink]="['/incentives']"><a>Incentives<div class="underline"></div></a></li>
            <li [routerLink]="['/sponsors']"><a>Sponsors<div class="underline"></div></a></li>
            <li [routerLink]="['/pastwin']"><a>Past Winners<div class="underline"></div></a></li>
            <!-- <li [routerLink]="['/fame']"><a>Hall of Fame<div class="underline"></div></a></li> -->
            <li [routerLink]="['/contact']"><a>Contact<div class="underline"></div></a></li>
            <li [routerLink]="['/mediapresence']"><a>Media Presence<div class="underline"></div></a></li>
            <li><a class="btn btn-lg inverse" (click)="register()">Login</a></li>
            <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
            <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
          </ul>


          <ul class="nav navbar-nav navbar-right switches extra-2" [ngClass]="{'show-nav': !isShow}">
            <li (click)="toggleDisplay($event)"><a href="#">Home<div class="underline"></div></a></li>
            <!-- other list items -->
            <li (click)="toggleDisplay($event)" [routerLink]="['/structure']"><a>Structure<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/tracks']"><a>Tracks<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/incentives']"><a>Incentives<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/sponsors']"><a>Sponsors<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/pastwin']"><a>Past Winners<div class="underline"></div></a></li>
            <!-- <li (click)="toggleDisplay($event)" [routerLink]="['/fame']"><a>Hall of Fame<div class="underline"></div></a></li> -->
            <li (click)="toggleDisplay($event)" [routerLink]="['/contact']"><a>Contact<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/mediapresence']"><a>Media Presence<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)"><a class="btn btn-lg inverse" (click)="register()">Login</a></li>
         </ul>
         
          <ul class="nav navbar-nav navbar-right switches extra-2" hidden>
            <li (click)="toggleDisplay($event)"><a href="#">Home<div class="underline"></div></a></li>
            <!-- <li (click)="toggleDisplay($event)"><a [routerLink]="['/land']">Home2<div class="underline active"></div></a></li> -->
            <li (click)="toggleDisplay($event)" [routerLink]="['/structure']"><a>Structure<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/tracks']"><a>Tracks<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/incentives']"><a>Incentives<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/sponsors']"><a>Sponsors<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/pastwin']"><a>Past Winners<div class="underline"></div></a></li>
            <!-- <li (click)="toggleDisplay($event)" [routerLink]="['/fame']"><a>Hall of Fame<div class="underline"></div></a></li> -->
            <li (click)="toggleDisplay($event)" [routerLink]="['/contact']"><a>Contact<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)" [routerLink]="['/mediapresence']"><a>Media Presence<div class="underline"></div></a></li>
            <li (click)="toggleDisplay($event)"><a class="btn btn-lg inverse" (click)="register()">Login</a></li>
            <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
            <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
          </ul>
        </div>
      </nav>
    </div>

    <div class="body" id="topheader" *ngIf="!isScreen">
      <nav class="navbar">
          <div class="container-fluid">
            <div class="navbar-header">
              <a class="imglogo" href="https://ecell.in" target="_blank"><img src="assets/images/logoblk.png" alt="E-Cell"></a>
              <div [className]="isnotOpen ? 'ham' : 'ham openham'"  (click) = toggleDisplay($event)>
                  <!-- <i class="fa-solid fa-bars fa-2xl"></i> -->
                  <span [className]="isnotOpen ? 'top' : 'top-open'"></span>
                  <span [className]="isnotOpen ? 'mid' : 'mid-open'"></span>
                  <span [className]="isnotOpen ? 'bottom' : 'bottom-open'"></span>
                  
                </div>
            </div>
            <!-- <ul class="nav navbar-nav">
              
            </ul> -->
            <!-- <button>Toggle</button> -->
            <ul class="nav navbar-nav navbar-right switches extra">
              <li><a href="#">Home<div class="underline active"></div></a></li>
              <!-- <li><a [routerLink]="['/land']">Home2<div class="underline active"></div></a></li> -->
              <li [routerLink]="['/structure']"><a >Structure<div class="underline"></div></a></li>
              <li [routerLink]="['/tracks']"><a>Tracks<div class="underline"></div></a></li>
              <li [routerLink]="['/incentives']"><a>Incentives<div class="underline"></div></a></li>
              <li [routerLink]="['/sponsors']"><a>Sponsors<div class="underline"></div></a></li>
              <li [routerLink]="['/pastwin']"><a>Past Winners<div class="underline"></div></a></li>
              <!-- <li [routerLink]="['/fame']"><a>Hall of Fame<div class="underline"></div></a></li> -->
              <li [routerLink]="['/contact']"><a>Contact<div class="underline"></div></a></li>
              <li [routerLink]="['/mediapresence']"><a>Media Presence<div class="underline"></div></a></li>
              <li><a class="btn btn-lg inverse" (click)="register()">Login</a></li>
              <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
              <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
            </ul>
            <ul class="nav navbar-nav navbar-right switches extra-2" [hidden]="isShow">
              <li (click)="toggleDisplay($event)"><a href="#">Home<div class="underline"></div></a></li>
              <!-- <li (click)="toggleDisplay($event)"><a [routerLink]="['/land']">Home2<div class="underline active"></div></a></li> -->
              <li (click)="toggleDisplay($event)" [routerLink]="['/structure']"><a>Structure<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)" [routerLink]="['/tracks']"><a>Tracks<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)" [routerLink]="['/incentives']"><a>Incentives<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)" [routerLink]="['/sponsors']"><a>Sponsors<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)" [routerLink]="['/pastwin']"><a>Past Winners<div class="underline"></div></a></li>
              <!-- <li (click)="toggleDisplay($event)" [routerLink]="['/fame']"><a>Hall of Fame<div class="underline"></div></a></li> -->
              <li (click)="toggleDisplay($event)" [routerLink]="['/contact']"><a>Contact<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)" [routerLink]="['/mediapresence']"><a>Media Presence<div class="underline"></div></a></li>
              <li (click)="toggleDisplay($event)"><a class="btn btn-lg inverse" (click)="register()">Login</a></li>
              <!-- <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
              <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li> -->
            </ul>
          </div>
        </nav>
      </div>

    <script>
        $( 'container-fluid .active' ).on('click', 
                    function () {
            $( 'container-fluid .navbar-nav' ).find( 'li.active' )
            .removeClass( 'active' );
            $( this ).parent( 'li' ).addClass( 'active' );
        });
    </script>